// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Eqtze","colBig":"styles_colBig__1qcMb","colSmall":"styles_colSmall__XTaGw"};